<ion-app>
  <ion-router-outlet id="menuContent"></ion-router-outlet>
  <div class="ipad-spinner" *ngIf="showIpadSpinner"></div>
<app-menu></app-menu>
</ion-app>